// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags-wrap[data-v-3d04edc9],\n.description-wrap[data-v-3d04edc9] {\n  color: var(--dark-500);\n  margin-top: 24px;\n  padding-top: 21px;\n  border-top: 1px solid #dbdbdb;\n}\n.tags-wrap .idm-input-container[data-v-3d04edc9],\n.tags-wrap .idm-textarea[data-v-3d04edc9],\n.description-wrap .idm-input-container[data-v-3d04edc9],\n.description-wrap .idm-textarea[data-v-3d04edc9] {\n  margin-top: 11px;\n}", ""]);
// Exports
module.exports = exports;
